// extracted by mini-css-extract-plugin
export var ButtonOrange = "j_h";
export var ButtonPrimary = "j_g";
export var articleSourceLink = "j_f";
export var break5 = "j_bl";
export var breakAll = "j_bk";
export var breakHeaderHowWorks = "j_bn";
export var breakHeaderReduceWord = "j_bq";
export var container = "j_j";
export var containerFluid = "j_k";
export var fallback5 = "j_bm";
export var fallbackHeaderHowWorks = "j_bp";
export var fallbackHeaderReduceWord = "j_br";
export var pillarNavContainer = "j_c";
export var smallBody = "j_b";
export var tptn_counter = "j_d";